module.exports = __webpack_public_path__ + "img/ag.cce32c73.svg";